const UNSAFE_PATTERNS = [
    /[<>]/,
    /javascript\s*:/i,
    /\bon\w+\s*=/i
];

export function safeTextValidator(value: string | null | undefined): boolean {
    if (!value) return true;

    return !UNSAFE_PATTERNS.some(pattern => pattern.test(value));
}
